// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--veXed","editCart":"styles-module__editCart--ViYgg"};